export default __webpack_public_path__ + "dc016eb38999fb9750befe00b6ac62d2.webp";